export const VER_CommentWibMessageContent = 1

export interface ICommentWibMessageContent {
    message: string
    version: number
}